/**
 * 加载配置并返回 SignalR 地址（含完整配置复用能力）
 * @returns {Promise<Object>} 配置对象（含 signalRUrl 及完整 baseConfig）
 */
export async function getConfig() {
  try {
    // 请求 public 目录下的 config.json
    const response = await fetch('/config.json');
    // 校验响应状态（补充优化：避免非 200 响应导致解析失败）
    if (!response.ok) {
      throw new Error(`配置请求失败，状态码：${response.status}`);
    }
    const baseConfig = await response.json();
    // 返回完整配置 + 拼接好的 SignalR 地址
    return {
      ...baseConfig,
      signalRUrl: `${baseConfig.signalRUrl}/subscriptionHub`
    };
  } catch (error) {
    console.error('加载配置文件失败：', error.message);
    // 兜底默认配置，确保程序不中断
    const defaultConfig = {
      apiBaseUrl: 'https://127.0.0.1',
      signalRUrl: 'https://127.0.0.1/subscriptionHub',
      timeout: 10000,
      "langType": 1
      // 可添加其他默认配置项...
    };
    return defaultConfig;
  }
}